import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.BowlingBinaryAnswer.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.BowlingBinaryAnswer.GameData;
  this.maxIterations = this.gameConfig.iterations;
  this.difficulty = 1;
  this.iteration = 0;
  this.labels = [];
  this.word = null;
  this.pins = [];
  this.balls = [];
};

EDC.Games.BowlingBinaryAnswer.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.BowlingBinaryAnswer.Scenes.Main.prototype.constructor = EDC.Games.BowlingBinaryAnswer.Scenes.Main;

const BBA = EDC.Games.BowlingBinaryAnswer.Scenes.Main.prototype;

BBA.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

BBA.createTemplateUI = function () {
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(500, 170, 'title').setOrigin(0.5);
  } else {
    title = this.make.text({
      x: 30,
      y: 30,
      text: this.gameConfig.titleTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '850' },
        lineSpacing: 5,
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(1500, 170, 'instructions').setOrigin(0.5);
  } else {
    instructions = this.make.text({
      x: 1505,
      y: 170,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: '600' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
};

BBA.loadIteration = function () {
  this.addLabels();
  this.addWord();
  this.addPins();
  this.addBalls();
};

BBA.addLabels = function () {
  const font = {
    font: `80px ${this.gameConfig.font}`,
  };
  const { left } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { right } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const leftContainer = this.add.container(350, 690);
  const leftText = this.add.text(0, 0, left, font).setOrigin(0.5);
  leftContainer.add(leftText);
  leftContainer.markAnim = new AnswerMark(this, leftContainer).setScale(0.25);
  leftContainer.setData('markAnim', leftContainer.markAnim);
  this.labels.push(leftContainer);

  const rightContainer = this.add.container(1590, 690);
  const rightText = this.add.text(0, 0, right, font).setOrigin(0.5);
  rightContainer.add(rightText);
  rightContainer.markAnim = new AnswerMark(this, rightContainer).setScale(0.25);
  rightContainer.setData('markAnim', rightContainer.markAnim);
  this.labels.push(rightContainer);
};

BBA.addWord = function () {
  const font = {
    font: `80px ${this.gameConfig.font}`,
  };
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { underline } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const wordContainer = this.add.container(0, 560);
  const word = this.make.text({
    x: 0,
    y: 0,
    text: question,
    origin: { x: 0, y: 0 },
    style: {
      fontFamily: `${this.gameConfig.font}`,
      fontSize: '80px',
      wordWrap: { width: `${this.gameConfig.questionsMaxWidth}`, useAdvancedWrap: true },
      lineSpacing: 10,
      align: 'center',
    },
  });
  wordContainer.add(word);
  this.adjustPositions(wordContainer, word, underline);
  wordContainer.setSize(word.displayWidth, word.displayHeight);
  this.word = wordContainer;
};

BBA.moveWord = function (answer) {
  const { leftX, rightX } = this.getWordTargetX();
  if (answer === 'left') {
    this.tweens.add({
      targets: this.word,
      x: leftX + 50,
      y: 510 - this.word.displayHeight / 2,
      duration: 150,
      ease: 'Linear',
    });
  } else {
    this.tweens.add({
      targets: this.word,
      x: rightX - 50,
      y: 510 - this.word.displayHeight / 2,
      duration: 200,
      ease: 'Linear',
    });
  }
};

BBA.getWordTargetX = function () {
  const wordWidth = this.word.width;
  const boardWidth = 495;
  const leftX = (700 - wordWidth) / 2;
  const rightX = (this.game.config.width + 1220 - wordWidth) / 2;
  return { leftX, rightX };
};

BBA.adjustPositions = function (container, word, underline) {
  let containerX;
  const wordWidth = word.displayWidth;
  let wordX = 0;
  const boardWidth = 495;
  const boardX = (this.game.config.width - boardWidth) / 2;
  wordX = boardX + (495 - wordWidth) / 2;
  container.x = wordX;
  if (underline) {
    const line = this.add.sprite(0, 0, 'underline').setOrigin(0);
    line.x = this.getUnderlineX(word) - (line.displayWidth - 20);
    line.y = word.displayHeight;
    container.add(line);
  }
};

BBA.getUnderlineX = function (word) {
  const font = {
    font: `80px ${this.gameConfig.font}`,
  };
  const { underline } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let x = 0;
  const letters = [];
  for (let i = 0; i < word.text.length; i++) {
    const letter = this.add.text(870 + x, 600, word.text[i], font);
    letters.push(letter);
    x += letter.displayWidth;
    if (i === underline - 1) {
      break;
    }
  }
  for (let i = 0; i < letters.length; i++) {
    letters[i].destroy();
  }
  return x;
};

BBA.addPins = function () {
  for (let i = 0; i < 5; i++) {
    const { x, y } = this.getPinPosition(i);
    const pin = this.add
      .sprite(x, y, 'pin')
      .setOrigin(0.5, 1)
      .setScale(0.25);
    pin.initY = y;
    this.pins.push(pin);
  }
  this.appearFromAbove();
};

BBA.appearFromAbove = function () {
  const shape = this.make.graphics().fillRect(850, 225, 250, 190);
  const geomask = shape.createGeometryMask();
  geomask.invertAlpha = true;
  for (let i = 0; i < this.pins.length; i++) {
    this.pins[i].setMask(geomask);
    this.pins[i].y = this.pins[i].y - 140;
    this.tweens.add({
      targets: this.pins[i],
      y: this.pins[i].initY,
      duration: 750,
      ease: 'Linear',
    });
  }
};

BBA.getPinPosition = function (index) {
  const x = 890 + index * 40;
  const y = 538;
  return { x, y };
};

BBA.rollThroughTunnel = function () {
  for (let i = 0; i < this.balls.length; i++) {
    const { x, y } = this.rollUpPositions(i);
    this.balls[i].x = x;
    this.balls[i].y = y;
    this.balls[i].setScale(0.3);
    this.balls[i].rolling = true;
    this.balls[i].body.setVelocity(110 * this.balls[i].rollDirection, 40);
    this.tweens.add({
      targets: this.balls[i],
      scaleX: 1,
      scaleY: 1,
      duration: 900,
      ease: 'Linear',
      onComplete: this.ballStartingPosition.bind(this),
    });
  }
};

BBA.ballStartingPosition = function () {
  for (let i = 0; i < this.balls.length; i++) {
    this.balls[i].body.stop();
    this.balls[i].rolling = false;
    this.ballHover(this.balls[i]);
  }
};

BBA.rollUpPositions = function (index) {
  const ballPosition = {
    0: { x: 290, y: 850 },
    1: { x: 1630, y: 850 },
  };
  return ballPosition[index];
};

BBA.addBalls = function () {
  let ballDirection = -1;
  for (let i = 1; i < 3; i++) {
    const { x, y } = this.getBallPosition(i);
    const ball = this.physics.add.sprite(x, y, `ball-${i}`);
    ball.init_x = x;
    ball.init_y = y;
    ball.rollDirection = ballDirection;
    ballDirection *= -1;
    if (i === 1) {
      ball.keyWord = 'left';
    } else {
      ball.keyWord = 'right';
    }
    const rect = new Phaser.Geom.Rectangle(0, 0, 200, 200);
    ball.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    this.cursorManager.setDefaultDraggableEvents(ball);
    this.input.setDraggable(ball);
    ball.on(
      'drag',
      ((sprite, pointer, x, y) => {
        sprite.setPosition(x, y);
      }).bind(this, ball),
    );

    ball.on('dragend', this.onDragStop.bind(this, ball), this);
    ball.on('dragstart', this.onDragStart.bind(this, ball), this);
    this.balls.push(ball);
  }
  this.rollThroughTunnel();
};

BBA.onDragStart = function (ball) {
  this.tweens.killTweensOf(ball);
};

BBA.onDragStop = function (ball) {
  if (ball.x > 600 && ball.x < 1300) {
    this.balls.map((x) => {
      x.disableInteractive();
    });
    this.placeAboveAlley(ball);
  } else {
    this.returnToSide(ball);
  }
};

BBA.placeAboveAlley = function (ball) {
  this.tweens.add({
    targets: ball,
    x: 950,
    y: 740,
    duration: 200,
    ease: 'Linear',
    onComplete: this.hitTheAlley.bind(this),
    onCompleteParams: [ball],
  });
};

BBA.hitTheAlley = function (tween, targets, ball) {
  this.tweens.add({
    targets: ball,
    x: 950,
    y: 830,
    duration: 150,
    ease: 'Linear',
    delay: 200,
    onComplete: this.startRolling.bind(this),
    onCompleteParams: [ball],
  });
};

BBA.getWordTargetX = function () {
  const wordWidth = this.word.width;
  const boardWidth = 495;
  const leftX = (700 - wordWidth) / 2;
  const rightX = (this.game.config.width + 1220 - wordWidth) / 2;
  return { leftX, rightX };
};

BBA.answerAnimations = function (ball, answer) {
  let wrongAnswer;
  if (answer === 'left') {
    wrongAnswer = this.labels[1];
  } else {
    wrongAnswer = this.labels[0];
  }
  if (ball.keyWord === answer) {
    this.moveWord(answer);
  } else {
    ball.setTint(0xff0000);
    wrongAnswer.first.setTint(0xff0000);
    wrongAnswer.getData('markAnim').showMark(false, () => {});
  }
};

BBA.startRolling = function (tween, targets, ball) {
  ball.rolling = true;
  const { correct } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  this.answerAnimations(ball, correct);
  if (ball.keyWord === correct) {
    this.playCorrect();
    ball.body.setVelocity(4, -80);
    this.tweens.add({
      targets: ball,
      scaleX: 0.45,
      scaleY: 0.45,
      duration: 4000,
      ease: 'Linear',
      onComplete: this.stopBody.bind(this),
      onCompleteParams: [ball],
    });
    this.time.addEvent({ delay: 4000, callback: this.pinCollision, callbackScope: this });
  } else {
    this.playWrong();
    ball.body.setVelocity(45, -80);
    this.tweens.add({
      targets: ball,
      scaleX: 0.45,
      scaleY: 0.45,
      duration: 4000,
      ease: 'Linear',
      onComplete: this.stopBody.bind(this),
      onCompleteParams: [ball],
    });
  }
};

BBA.stopBody = function (tween, targets, ball) {
  if (ball.keyWord === 'left') {
    this.balls[1].setInteractive();
  } else {
    this.balls[0].setInteractive();
  }
  ball.body.stop();
  ball.rolling = false;
  this.tweens.add({
    targets: ball,
    alpha: 0,
    duration: 800,
    ease: 'Linear',
  });
};

BBA.pinCollision = function (tween, targets, ball) {
  let direction = 1;
  for (let i = 0; i < this.pins.length; i++) {
    this.tweens.add({
      targets: this.pins[i],
      angle: -90 * direction,
      duration: 500,
      ease: 'Linear',
    });
    direction *= -1;
  }
  this.removePins();
  this.time.addEvent({ delay: 2000, callback: this.nextIteration, callbackScope: this });
};

BBA.nextIteration = function () {
  this.iteration++;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.word.destroy();
    this.word = null;
    this.pins.map((x) => {
      x.destroy();
    });
    this.pins = [];
    this.balls.map((x) => {
      x.destroy();
    });
    this.balls = [];
    this.labels.map((x) => {
      x.destroy();
    });
    this.labels = [];
    this.loadIteration();
  }
};

BBA.removePins = function () {
  for (let i = 0; i < this.pins.length; i++) {
    this.tweens.add({
      targets: this.pins[i],
      alpha: 0,
      duration: 1500,
      ease: 'Linear',
    });
  }
};

BBA.update = function () {
  for (let i = 0; i < 2; i++) {
    // keeps ball rotating.
    if (this.balls[i]) {
      if (this.balls[i].rolling === true) {
        this.balls[i].angle += 6.5 * this.balls[i].rollDirection;
      } else {
        this.balls[i].angle = 0;
      }
    }
  }
};

BBA.returnToSide = function (ball) {
  ball.x = ball.init_x;
  ball.y = ball.init_y;
  this.ballHover(ball);
};

BBA.getBallPosition = function (index) {
  const ballPosition = {
    1: { x: 190, y: 885 },
    2: { x: 1750, y: 885 },
  };
  return ballPosition[index];
};

BBA.ballHover = function (ball) {
  const tween1 = this.tweens.add({
    targets: ball,
    y: ball.y - 8,
    duration: 1000,
    ease: 'Sine.easeInOut',
    repeat: -1,
    yoyo: true,
  });
};

export default EDC.Games.BowlingBinaryAnswer.Scenes.Main;
